/** API route map: URLS.Controller.CrimCheck */
export const CrimCheck = {
      Name: 'CrimCheck/',
      GetProducts: 'get-products',
      GetBillingCodes: 'get-crimcheck-billing-code',
      AddBillingCode: 'add-billing-code',
      DeleteBillingCode: 'delete/',
      AddAttachment: 'add-attachment',
      CreateOrder: 'create-order',
      GetAllOrders: 'get-all-orders',
      GetOrderById: 'get-order/',
      GetOrderStatusById: 'get-order-status/',
      GetOrderDetail: 'get-order-detail/',
      AddAttachmentDetail: 'add-attachment-detail',
      DeleteAttachment: 'delete-attachment/',
};
